import { useContext, useEffect } from "react";
import { UseFormReset } from "react-hook-form";

import useFetch from "../useFetch";
import { ToastContext } from "src/context/toastContext";
import { AuthContext } from "src/context/authContext";

import { ToastTypes } from "src/types";
import { AddProviderResponse } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import { AddProviderForm, NPISpeciality } from "src/pages/addProvider/types";



const useAddNewProvider = (title: string, resetForm: UseFormReset<AddProviderForm>, specialityData?: NPISpeciality[]) => {
  const { showToast } = useContext(ToastContext)
  const { userData } = useContext(AuthContext)


  const {
    loading: addProviderLoading,
    data: addProviderResponse,
    mutate: callAddProvider,
    removeErrorAndData: refreshAddProviderRequest
  } = useFetch<AddProviderResponse>(APIEndpoints.ADD_PROVIDER);

  useEffect(() => {
    if (addProviderResponse) {
      const { status: { code, message } } = addProviderResponse;
      if (code === 200) {
        if (message.includes("already exists"))
          showToast([message], ToastTypes.ERROR)
        else
          showToast(['Provider Saved Successfully'], ToastTypes.SUCCESS);
        // resetForm();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addProviderResponse]);

  /**
   * @Fourth
   */
  const addNewProvider = async (values: AddProviderForm) => {
    refreshAddProviderRequest();

    if (userData) {
      const { id } = userData;
      let doctor_type;

      if (title) {
        if (title.includes("Referring")) doctor_type = "referring"
        if (title.includes("Treating")) doctor_type = "treating"
      }

      const res = {
        user_id: id,
        ...(doctor_type ? { doctor_type } : {}),
        global_doctor: {
          ...values,
          ref_taxonomy_id: ( specialityData?.find((speciality) => speciality.code === values.ref_taxonomy_id)?.id || 0).toString(),
        },
      };
      callAddProvider(res);
    }
  };

  return { addProviderLoading, addProviderResponse, addNewProvider }
}

export default useAddNewProvider
